import React from 'react'

const DieWiseReport = () => {
  return (
    <div>DieWiseReport</div>
  )
}

export default DieWiseReport